<template>
  <li class="dropdown-container">
    <button
      :ref="`list${uniqueID}`"
      :id="uniqueID + '-header'"
      :aria-controls="uniqueID + '-panel'"
      :aria-expanded="isExpanded ? 'true' : 'false'"
      @click="toggle"
      class="accordion-trigger"
    >
      <template>
        <template v-if="!isChevron">
          <span aria-hidden="true" v-if="!isExpanded" class="plus">+</span>
          <span aria-hidden="true" v-else class="minus">-</span></template
        >

        <h2>{{ title }}</h2>
        <template v-if="isChevron">
          <span aria-hidden="true" v-if="!isExpanded" class="plus chevron"
            ><img alt src="../../assets/images/Accordion/ChevronDownIcon.webp"
          /></span>
          <span aria-hidden="true" v-else class="minus chevron"
            ><img alt src="../../assets/images/Accordion/ChevronUpIcon.webp"
          /></span>
        </template>
      </template>
    </button>
    <div class="accordion-content">
      <transition @enter="enter" @after-enter="afterEnter" @leave="leave" name="slide">
        <div :id="uniqueID + '-panel'" :aria-labelledby="uniqueID + '-header'" v-show="isExpanded" class="panel">
          <slot></slot>
        </div>
      </transition>
    </div>
  </li>
</template>
<script>
export default {
  name: 'AccordionItem',
  props: {
    title: { type: String, required: true },
    isChevron: { type: Boolean, default: false },
    onTrigger: { type: Function, required: false, default: null },
  },
  data() {
    return {
      uniqueID: Math.random().toString(36).substring(2, 15),
      isExpanded: false,
      accordionID: this.$parent.accordionID,
    };
  },
  computed: {
    isMobile() {
      return this.$resize && this.$mq.below(1130);
    },
  },
  methods: {
    toggle() {
      if (this.onTrigger) {
        this.onTrigger();
      }

      if (this.isExpanded) {
        this.isExpanded = false;
      } else {
        this.$root.$emit('toggleAccordion', {
          accordionID: this.accordionID,
          uniqueID: this.uniqueID,
        });
      }
    },
    enter(elParam) {
      const element = elParam;
      const { width } = getComputedStyle(element);
      element.style.width = width;
      element.style.height = 'auto';

      const { height } = getComputedStyle(element);
      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // eslint-disable-next-line
      getComputedStyle(element).height;

      this.$nextTick(() => {
        element.style.height = height;
        element.style.width = null;
        element.style.position = null;
        element.style.visibility = null;
      });
    },
    afterEnter(elParam) {
      const element = elParam;
      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 'auto';
    },
    leave(elParam) {
      const element = elParam;
      const { height } = getComputedStyle(element);
      element.style.height = height;

      // eslint-disable-next-line
      getComputedStyle(element).height;

      this.$nextTick(() => {
        element.style.height = 0;
      });
    },
  },
  mounted() {
    this.$root.$on('refreshAccordion', (data) => {
      if (this.accordionID === data.accordionID) {
        if (this.uniqueID === data.uniqueID) {
          this.isExpanded = true;
        } else {
          this.isExpanded = false;
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.dropdown-container {
  overflow: hidden;
  cursor: pointer;
  border-bottom: 1px solid $c-border-blue;

  &:last-child {
    border-bottom: 1px solid transparent;
  }

  button {
    color: $c-primary;
    margin: 0;
    padding: 0;
    padding: 18px 0 20px 0;
    width: 100%;
    padding-left: 5px;

    &:focus {
      outline-offset: -3px;
    }

    h2 {
      margin-bottom: 0;
      font-size: 24px;
    }
  }
  button:not(.main-heading):not(.sub-heading) {
    font-size: 24px;
    font-weight: 600;
  }
  .slide-enter-active,
  .slide-leave-active {
    transition: height 0.3s ease-in-out;
  }
  .slide-enter,
  .slide-leave-to {
    height: 0;
  }
}
.accordion-trigger {
  display: flex;
  background: transparent;
  font-size: inherit;
  font-family: inherit;
  border: none;
  padding: 0;
  margin: 0;
  text-align: left;
  font-weight: inherit;
  color: inherit;
  .plus,
  .minus {
    min-width: 30px;
    display: inline-block;
  }
}
//! Note: changes for AggregateFAQ page, as it has different style for heading
.main-heading {
  margin: 0;
  flex: 1;
  font-weight: 600;
  font-size: 24px;
  @media (min-width: 750px) {
    font-size: 42px;
  }
}
.sub-heading {
  font-weight: $fw-medium;
  line-height: 1;
  font-size: 18px;
}
.width100 {
  width: 100%;
}
.plus2,
.minus2 {
  text-align: right;
  font-weight: $fw-light;
  font-size: 24px;
  @media (min-width: 750px) {
    font-size: 50px;
  }
}
.mobile-faqs-heading {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.chevron {
  right: 40px;
  position: absolute;
}
</style>
